










import { Vue, Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "transactions-listing": () =>
      import("@/components/app/admin/transactions/transactionsListing.vue"),
    "transactions-provider": () =>
      import("@/components/app/admin/transactions/transactionsProvider.vue")
  }
})
export default class AdminClientAllTransactions extends Vue {
  // Props
  @Prop({ required: true })
  public client!: IClient;
}
